module.exports = __webpack_public_path__ + "static/hero-background-1ad1b803f6ce20e79cc27dcc41fd0ec8.png";